export default __webpack_public_path__ + "static/media/Avatar-7.16a5cd75.png";